/* youthfulbloom - cart drawer.
   Owns every add-to-cart on the site: the grid quick-add, the product form
   and the sticky bar all route through here so the drawer always opens. */
(function () {
  var root = document.getElementById('ybCart');
  if (!root) return;

  var itemsBox = root.querySelector('[data-yb-cart-items]');
  var countEl  = root.querySelector('[data-yb-cart-count]');
  var totalEl  = root.querySelector('[data-yb-cart-total]');
  var promo    = root.querySelector('[data-yb-cart-promo]');
  var promoTxt = root.querySelector('[data-yb-cart-promotext]');
  var bar      = root.querySelector('[data-yb-cart-bar]');
  var upsell   = root.querySelector('[data-yb-upsell]');

  var freeAt   = Number(root.dataset.freeThreshold || 0) * 100;   /* cents */
  var bundleAt = Number(root.dataset.bundleThreshold || 0);       /* item count */
  var bundleSave = Number(root.dataset.bundleSave || 0);

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function setOpen(open) {
    root.dataset.open = String(open);
    root.setAttribute('aria-hidden', String(!open));
    document.body.style.overflow = open ? 'hidden' : '';
  }

  function lineHTML(item, i) {
    var img = item.image
      ? '<img class="yb-line__img" src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="" loading="lazy">'
      : '<span class="yb-line__img"></span>';

    var opts = (item.options_with_values || [])
      .map(function (o) { return o.name + ': ' + o.value; }).join('  ');

    var price = '';
    if (item.original_price > item.final_price) {
      price = '<s>' + money(item.original_price) + '</s> ' + money(item.final_price) +
              ' <span class="yb-line__save">(Save ' + money(item.original_price - item.final_price) + ')</span>';
    } else {
      price = money(item.final_price);
    }

    return '<div class="yb-line">' +
      '<a href="' + item.url + '">' + img + '</a>' +
      '<div class="yb-line__main">' +
        '<h3 class="yb-line__title">' + item.product_title + '</h3>' +
        (opts ? '<p class="yb-line__opt">' + opts + '</p>' : '') +
        '<div class="yb-line__price">' + price + '</div>' +
        '<div class="yb-qty">' +
          '<button type="button" data-yb-qty="' + (i + 1) + '" data-to="' + (item.quantity - 1) + '" aria-label="Decrease">&minus;</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" data-yb-qty="' + (i + 1) + '" data-to="' + (item.quantity + 1) + '" aria-label="Increase">+</button>' +
        '</div>' +
      '</div>' +
      '<button class="yb-line__remove" type="button" data-yb-qty="' + (i + 1) + '" data-to="0" aria-label="Remove">' +
        '<svg viewBox="0 0 24 24"><path d="M4 7h16M9 7V5h6v2M7 7l1 13h8l1-13"/></svg>' +
      '</button>' +
    '</div>';
  }

  function renderPromo(cart) {
    /* Free shipping progress takes priority; then the bundle nudge. */
    if (freeAt > 0 && cart.total_price < freeAt) {
      promo.hidden = false;
      promoTxt.innerHTML = 'Spend <strong>' + money(freeAt - cart.total_price) +
                           ' more</strong> and get free shipping';
      bar.style.width = Math.min(100, (cart.total_price / freeAt) * 100) + '%';
      return;
    }
    if (freeAt > 0 && cart.total_price >= freeAt) {
      promo.hidden = false;
      promoTxt.innerHTML = '<strong>Free shipping unlocked</strong>';
      bar.style.width = '100%';
      return;
    }
    if (bundleAt > 0 && bundleSave > 0 && cart.item_count > 0 && cart.item_count < bundleAt) {
      var need = bundleAt - cart.item_count;
      promo.hidden = false;
      promoTxt.innerHTML = 'Save <strong>$' + bundleSave + '</strong> when you add ' +
                           need + ' more item' + (need === 1 ? '' : 's');
      bar.style.width = ((cart.item_count / bundleAt) * 100) + '%';
      return;
    }
    promo.hidden = true;
  }

  function render(cart) {
    if (countEl) countEl.textContent = cart.item_count ? '• ' + cart.item_count : '';
    if (totalEl) totalEl.textContent = cart.item_count ? '• ' + money(cart.total_price) : '';

    itemsBox.innerHTML = cart.items.length
      ? cart.items.map(lineHTML).join('')
      : '<p class="yb-cart__empty">Your cart is empty.</p>';

    renderPromo(cart);

    /* hide upsell rows for things already in the cart */
    if (upsell) {
      var inCart = cart.items.map(function (i) { return i.handle; });
      var left = 0;
      upsell.querySelectorAll('[data-yb-up]').forEach(function (row) {
        var dup = inCart.indexOf(row.dataset.upHandle) !== -1;
        row.hidden = dup || left >= 4;
        if (!row.hidden) left++;
      });
      upsell.hidden = cart.items.length === 0 || left === 0;
    }

    document.querySelectorAll('[data-yb-cart-count]').forEach(function (el) {
      if (el === countEl) return;
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
  }

  function refresh(open) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); if (open) setOpen(true); })
      .catch(function () {});
  }

  function addVariant(id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return refresh(true);
    });
  }

  /* ---- open / close ---- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-yb-cart-close]')) { setOpen(false); return; }

    /* the header bag opens the drawer instead of loading /cart */
    var bag = e.target.closest('a[href$="/cart"], a[href*="/cart?"]');
    if (bag && !e.metaKey && !e.ctrlKey) {
      e.preventDefault();
      refresh(true);
      return;
    }

    var up = e.target.closest('[data-yb-up-add]');
    if (up) {
      e.preventDefault();
      up.disabled = true;
      addVariant(up.dataset.ybUpAdd, 1).then(function () { up.disabled = false; });
      return;
    }

    var qty = e.target.closest('[data-yb-qty]');
    if (qty) {
      e.preventDefault();
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(qty.dataset.ybQty), quantity: Number(qty.dataset.to) })
      }).then(function () { refresh(false); });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.dataset.open === 'true') setOpen(false);
  });

  /* ---- product form posts through the drawer, not a page load ---- */
  var pform = document.querySelector('[data-yb-pform]');
  if (pform) {
    pform.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = pform.querySelector('[data-yb-variant-input]');
      if (!id) return;
      addVariant(id.value, 1);
    });
  }

  /* ---- grid quick-add hands off to us ---- */
  window.ybCartAdd = function (variantId) { return addVariant(variantId, 1); };
  window.ybCartOpen = function () { refresh(true); };

  refresh(false);
})();
